import { useState } from 'react';
import Hero from './components/Hero';
import UnifiedImporter from './components/UnifiedImporter';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import TestimonialsSection from './components/TestimonialsSection';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import WaitlistPopup from './components/WaitlistPopup';

export default function HomePage() {
  const [isWaitlistOpen, setIsWaitlistOpen] = useState(false);

  const openWaitlist = () => setIsWaitlistOpen(true);
  const closeWaitlist = () => setIsWaitlistOpen(false);

  return (
    <div className="min-h-screen bg-white">
      <Hero onOpenWaitlist={openWaitlist} />
      <ProblemSection />
      <UnifiedImporter />
      <TestimonialsSection />
      <SolutionSection />
      <FinalCTA onOpenWaitlist={openWaitlist} />
      <Footer />
      
      {/* Waitlist Popup */}
      <WaitlistPopup isOpen={isWaitlistOpen} onClose={closeWaitlist} />
    </div>
  );
}
